// extracted by mini-css-extract-plugin
module.exports = {"container":"dialogWrapper_container__7AiaM","title":"dialogWrapper_title__1W2Z9","content":"dialogWrapper_content__2t4Ry","actions":"dialogWrapper_actions__2j17w"};